"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "In welchem regionalen Umkreis sind Sie für Projekte tätig?",
  answer: "Unser Hauptsitz liegt in der Region, und wir führen die meisten Arbeiten in einem Umkreis von ca. 50 Kilometern aus. Für größere Erdarbeiten oder komplexe Tiefbauprojekte sind wir nach Absprache auch überregional für Sie im Einsatz."
}, {
  question: "Wie läuft die Erstellung eines Kostenvoranschlags ab?",
  answer: "Nach Ihrer Anfrage vereinbaren wir kurzfristig einen Besichtigungstermin vor Ort. Wir analysieren die Bodenbeschaffenheit und den Arbeitsumfang, um Ihnen innerhalb weniger Tage ein transparentes und verbindliches Festpreisangebot zu erstellen."
}, {
  question: "Mit welchen Zeitabläufen muss ich bei Erdarbeiten rechnen?",
  answer: "Die Dauer hängt stark vom Projektumfang ab. Kleinere Fundamentaushübe erledigen wir oft an einem Tag. Umfangreiche Außenanlagen oder Pflasterarbeiten planen wir detailliert im Voraus, sodass Sie sich auf unsere Terminzusagen verlassen können."
}, {
  question: "Verfügen Sie über einen eigenen Maschinenpark?",
  answer: "Ja, BauPartner arbeitet ausschließlich mit eigenem, modernem Gerät. Unser Fuhrpark umfasst verschiedene Baggergrößen, Radlader und Rüttelplatten, was uns maximale Flexibilität und Unabhängigkeit von Mietstationen ermöglicht."
}, {
  question: "Übernehmen Sie auch die Entsorgung von Erdaushub?",
  answer: "Selbstverständlich. Wir kümmern uns nicht nur um den Aushub, sondern auch um den fachgerechten Abtransport und die zertifizierte Entsorgung von Boden und Bauschutt. So erhalten Sie bei uns alle Leistungen sauber aus einer Hand."
}];
export default function FaqHilfeCenter() {
  return <section data-section-id="87082" id="häufige-fragen-vorab" className="py-20 !text-[hsl(45,93%,47%)] !bg-[hsl(41,96%,40%)] md:py-32">
      <div className="mx-auto max-w-[800px] px-4 sm:px-6">
        <div className="mb-12 md:mb-16 text-center md:text-left">
          <h2 className="font-sans text-4xl font-bold mb-4 tracking-tighter uppercase !text-[hsl(0,0%,100%)] md:text-5xl">
            Häufige Fragen vorab
          </h2>
          
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border data-[state=open]:bg-muted/50 transition-colors duration-300">
              <AccordionTrigger className="focus-visible:border-ring focus-visible:ring-ring/50 flex flex-1 items-start justify-between gap-4 rounded-md transition-all outline-none focus-visible:ring-[3px] [&[data-state=open]>svg]:rotate-180 font-sans text-xl font-bold py-6 px-4 text-left tracking-tight !text-[hsl(0,0%,100%)] disabled:pointer-events-none disabled:opacity-50 md:text-2xl hover:no-underline md:px-6">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base leading-relaxed px-4 md:px-6 pb-6 font-sans">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}